import Tone from 'tone';
import AmpEnvelope from './AmpEnvelope.js';

// Each output node will contain an OutputNodeVoice
// for oscillator
var ampCount = 0;
var ampCount = 0;
export default class OscillatorOutputs {
    constructor(oscillator, sequencerEngine, mixSession, context) {
        this.sequencerEngine = sequencerEngine;
        this.mixSession = mixSession;
        this.context = context;
        this.ampEnvelopes = [
            new AmpEnvelope(
                sequencerEngine, mixSession, context)
        ];
        this.connected = false;
    }

    dispose() {
        this.ampEnvelopes.forEach(
            x => x.dispose());
        this.ampEnvelopes = undefined;
    }

    newVoice() {
        this.ampEnvelopes.push(
            new AmpEnvelope(
                this.sequencerEngine, this.mixSession, this.context));
    }

    removeVoice() {
        this.ampEnvelopes[this.ampEnvelopes.length - 1].dispose();
        this.ampEnvelopes.splice(this.ampEnvelopes.length - 1, 1);
    }
}
